import { generatePath } from "@routes/utils.ts";

const pathBase = `/candidates/approve/`;

export const approve = {
  post: () => generatePath(pathBase, null),
};
